import {
  Component,
  ContentChild,
  EventEmitter, forwardRef, Input,
  Output,
  TemplateRef,
} from "@angular/core";
import {AutoUnsub} from "../../decorators";
import {TableCompComponent} from "./tableComp.component";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
  selector: 'app-table-selectable',
  templateUrl: './tableSelectable.component.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TableSelectableComponent),
    multi: true,
  }]
})
@AutoUnsub()
export class TableSelectableComponent  extends TableCompComponent {
  @Input() editOnDblclick = true;
  @Output() callbackSelectChange: any = new EventEmitter<any[]>();

  @ContentChild('header') templateHeader: TemplateRef<any>;

  public isSelectedAll = false;


  /**
   * Выбрать все отображаемые записи
   * @param list - список элементов
   */
  selectAll(list: Array<any>) {
    this.isSelectedAll = !this.isSelectedAll;
    list.forEach(item => {
      item.$selected = this.isSelectedAll;
    });
    this.onSelectChange();
  }

  /**
   * Получить выбранные записи
   * @param list - список, из которого выбрать записи
   */
  getSelectedModel(): Array<any> {
    return this.formArrayApp.filter(item => item.$selected === true);
  }

  /**
   * Проверка выбрано ли что-то
   * @param list - список
   */
  checkSizeSelectedModel(): boolean {
    return this.getSelectedModel().length > 0;
  }

  /**
   * Сбростить флаг "Выделить все"
   */
  resetSelectedAll() {
    this.isSelectedAll = false;
  }

  /**
   * Выбор строки снять/выдеилть
   * @param item - строка
   */
  selectRow(item: any, event?: Event) {
    item.$selected = !item.$selected;
    this.resetSelectedAll()
    this.onSelectChange();
  }

  onSelectChange(): void {
    this.callbackSelectChange.emit();
  }

  ngOnDestroy() {
    this.formArrayApp.forEach(item => {
      item.$selected = false;
    });
  }
}
